import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./Calculator.css";

const countries = {
    "Grenada": ["ST George"],
    "Jamaica": ["Kingston"],
    "Guyana": ["Georgetown"],
    "Saint Vincent": ["Kingstown"],
    "Kenya": ["Mombasa"],
    "Tanzania": ["Dar as salam"],
    "Uganda": ["Mombasa"],
    "Malawi": ["Dar as salam"],
    "Bahamas": ["Nassau"],
    "Aruba": ["Oranjestad"],
    "Sri Lanka": ["Hambantota"],
    "Zimbabwe": ["Durban"],
    "Trinidad And Tabaco": ["Port of Spain"],
    "New Zealand": ["Auckland"],
    "Saint Lucia": ["castries"],
    "Barbados": ["Bridgetown"],
    "Zambia": ["Darus Salam"],
    "Mozambique": ["Darus Salam"],
    "Cayman Islands": ["Georgetown"],
    "Mauritius": ["Louis Harbour"],
    "Antigua": ["st Johns"]
};

const Calculator = () => {
    const { carId } = useParams();
    const [carDetails, setCarDetails] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedPort, setSelectedPort] = useState("");
    const [ports, setPorts] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [formData, setFormData] = useState({ firstName: "", email: "", tel: "", address: "", city: "" });
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        fetch(`https://skcapi.btcjapan.co/get-car-details-with-images.php?id=${carId}`)
            .then(response => response.json())
            .then(data => {
                setCarDetails(data.carDetails);
                setIsLoading(false);
            })
            .catch(error => {
                console.error("Error fetching car details:", error);
                setIsLoading(false);
            });
    }, [carId]);

    const handleCountryChange = (e) => {
        const country = e.target.value;
        setSelectedCountry(country);
        setSelectedPort("");
        if (country) {
            setPorts(countries[country] || []);
        } else {
            setPorts([]);
        }
    };

    const handlePortChange = (e) => {
        setSelectedPort(e.target.value);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleAskClick = () => {
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const message = `
            Subject: Kindly provide the Price and freight rate of the product

            Vehicle Details:
            - Maker: ${carDetails.maker}
            - Model: ${carDetails.model}
            - Country: ${carDetails.country}
            - Year: ${carDetails.year}
            - Stock Number: ${carDetails.stock_id}
            - Chassis Number: ${carDetails.vin}

            Customer Details:
            - First Name: ${formData.firstName}
            - Email: ${formData.email}
            - Tel: ${formData.tel}
            - Address: ${formData.address}
            - City: ${formData.city}
            - Country: ${selectedCountry}
            - Port: ${selectedPort}

            Please provide the price and freight rate for the above vehicle.
        `;

        fetch('https://skcapi.btcjapan.co/email_whatsapp.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ name: formData.firstName, email: formData.email, subject: 'Kindly provide the Price and freight rate of the product', message }),
        })
            .then(response => response.json())
            .then(data => {
                console.log(data.message);
                if (data.status === 'success') {
                    setShowPopup(false);
                    setFormData({ firstName: "", email: "", tel: "", address: "", city: "" });
                    alert("Your request has been submitted successfully!");
                }
            })
            .catch(error => console.log('Error:', error));
    };

    if (isLoading) {
        return (
            <div className="calculator-loading">
                <div className="calculator-spinner"></div>
                <p>Loading vehicle details...</p>
            </div>
        );
    }

    if (!carDetails) {
        return (
            <div className="calculator-error">
                <h3>Error loading vehicle details</h3>
                <p>Please try again later.</p>
            </div>
        );
    }

    return (
        <div className="calculator-container">
            <div className="calculator-header">
                <h1>Vehicle Shipping Calculator</h1>
                <p>Get an instant quote for shipping your vehicle</p>


                <div className="calculator-content">
                    <div className="vehicle-info-card">
                        <div className="vehicle-info">
                            <h2>{carDetails.maker} <span className="vehicle-span">{carDetails.model}</span></h2>
                            <div className="vehicle-specs">
                                <div className="spec-item">
                                    <span className="spec-label">Year:</span>
                                    <span className="spec-value">{carDetails.year}</span>
                                </div>
                                <div className="spec-item">
                                    <span className="spec-label">Stock ID:</span>
                                    <span className="spec-value">{carDetails.stock_id}</span>
                                </div>
                                <div className="spec-item">
                                    <span className="spec-label">Chassis:</span>
                                    <span className="spec-value">{carDetails.vin}</span>
                                </div>
                                <div className="spec-item">
                                    <span className="spec-label">Origin:</span>
                                    <span className="spec-value">{carDetails.country}</span>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="calculator-form-card">
                        <div className="form-header">
                            <h3>Shipping Calculator</h3>
                            <p>Select destination to get a quote</p>
                        </div>

                        <div className="form-content">
                            <div className="input-group">
                                <label>Destination Country</label>
                                <select
                                    value={selectedCountry}
                                    onChange={handleCountryChange}
                                    className="form-select"
                                >
                                    <option value="">Select country</option>
                                    {Object.keys(countries).map((country) => (
                                        <option key={country} value={country}>
                                            {country}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="input-group">
                                <label>Destination Port </label>
                                <select
                                    value={selectedPort}
                                    onChange={handlePortChange}
                                    disabled={!selectedCountry}
                                    className="form-select"
                                >
                                    <option value="">Select port </option>
                                    {ports.map((port) => (
                                        <option key={port} value={port}>
                                            {port}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <button
                                className="quote-btn"
                                onClick={handleAskClick}
                                disabled={!selectedCountry || !selectedPort}
                            >
                                Request Price Quote
                            </button>
                        </div>
                    </div>

                </div>
            </div>

            {showPopup && (
                <div className="calculator-modal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>Request Price Quote</h3>
                            <button className="close-btn" onClick={handleClosePopup}>×</button>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <p className="modal-description">Please provide your details to get a customized price quote for your vehicle shipping.</p>

                                <div className="input-group">
                                    <label>First Name *</label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleInputChange}
                                        placeholder="Your first name"
                                        required
                                    />
                                </div>

                                <div className="input-group">
                                    <label>Email Address *</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        placeholder="Your email address"
                                        required
                                    />
                                </div>

                                <div className="input-group">
                                    <label>Phone Number *</label>
                                    <input
                                        type="tel"
                                        name="tel"
                                        value={formData.tel}
                                        onChange={handleInputChange}
                                        placeholder="Your phone number"
                                        required
                                    />
                                </div>

                                <div className="input-group">
                                    <label>Address *</label>
                                    <input
                                        type="text"
                                        name="address"
                                        value={formData.address}
                                        onChange={handleInputChange}
                                        placeholder="Your full address"
                                        required
                                    />
                                </div>

                                <div className="input-group">
                                    <label>City *</label>
                                    <input
                                        type="text"
                                        name="city"
                                        value={formData.city}
                                        onChange={handleInputChange}
                                        placeholder="Your city"
                                        required
                                    />
                                </div>

                                <div className="input-group">
                                    <label>Country *</label>
                                    <select
                                        name="country"
                                        value={selectedCountry}
                                        onChange={handleCountryChange}
                                        required
                                    >
                                        <option value="">Select your country</option>
                                        {Object.keys(countries).map((country) => (
                                            <option key={country} value={country}>
                                                {country}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="cancel-btn" onClick={handleClosePopup}>Cancel</button>
                                <button type="submit" className="submit-btn">Get Price Quote Now</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Calculator;